


















































import { plainToInstance } from 'class-transformer'
import { isEqual } from "lodash";
import { Component } from 'vue-property-decorator'

import MessageEditorWithMediaData from '../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import MultiMessageEditorWithMedia from '../../../NewMessageEditors/NewMultiMessageEditorWithMedia/MultiMessageEditorWithMedia.vue'
import { MessageEditorComponentSettings } from "../../../NewMessageEditors/types";
import FieldWrapper from '../../../Pi/components/FieldWrapper.vue'
import SettingWrapper from '../../../SettingWrapper.vue';
import { BaseInput } from '../../mixins'
import { FieldData } from "../../types";

@Component({
  methods: {
    isEqual
  },
  components: {
    MultiMessageEditorWithMedia,
    FieldWrapper,
    SettingWrapper
  },
})
export default class MultiMessageEditorWithMediaInput extends BaseInput {
  get editorValue() {
    if (Array.isArray(this.value)) {
      if (this.value[0] instanceof MessageEditorWithMediaData) {
        return this.value
      } else {
        return plainToInstance(MessageEditorWithMediaData, this.value)
      }
    }

    return this.value
  }

  set editorValue(value: any) {
    this.value = value
  }

  get defaultValueMessageEditorModel() {
    return this.getSettings().defaultValue
  }

  get editorSettings() {
    return this.getSettings<FieldData & MessageEditorComponentSettings>()
  }

  customDefaultValueSetter() {
    if (this.defaultValue && this.defaultValueMessageEditorModel) {
      this.value = []

      this.$nextTick(() => {
        this.value = this.defaultValueMessageEditorModel
      })
    }
  }

  mounted() {
    if (this.settings.settingWrapper !== undefined) {
      this.disabledSettingValueActive = isEqual(this.disabledOrActiveValue, this.value) || ((this.$slots['value-stub'] ?? false) && isEqual(this.disabledOrActiveValue, this.value))
    }
  }
}
